import styles from "./Menu.module.scss";

function Menu({ show, items, position = "right" }) {

  if (!show) {
    return null;
  }

  return (
    <div className={`${styles["menu-panel__overlay"]} ${styles[`menu-panel__overlay--${position}`]}`}>
      <div className={`${styles["menu-panel__main"]} ${styles[`menu-panel__main--${position}`]}`}>
        <div className={styles["menu-panel__header"]}>
          <div className={styles["menu-panel__title"]}>actions</div>
        </div>
        <ul>
          {items.map((e) => (
            <li key={e.name} onClick={e.action} id={`action-${e.name}`}>
              {e.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Menu;
